import axios from 'axios'

const CHAPTER = process.env.VUE_APP_CHAPTER

class ChapterCalls {

  create(chapter) {
    return axios.post(CHAPTER + "create/", { chapter }, { withCredentials: true })
    .then(response => response.data.chapter);
  }

  get(id) {
    return axios.get(CHAPTER + "id/" + id)
    .then(response => response.data.chapter);
  }

  getByAuthor(author, options = null) {
    return axios.post(CHAPTER + "author/" + author, { options })
    .then(response => response.data.chapters);
  }

  getByGroup(group, options = null) {
    return axios.post(CHAPTER + "group/" + group, { options })
    .then(response => response.data.chapters);
  }

  getByGroups(groups, options = null) {
    return axios.post(CHAPTER + "ids/group_ids", { groups, options })
    .then(response => response.data.chapters);
  }

  getAll(options = null) {
    return axios.post(CHAPTER + "all/", { options })
    .then(response => response.data.chapters);
  }

  view(chapterId) {
    return axios.get(CHAPTER + `id/${chapterId}/view`)
    .then(response => response.data);
  }

  edit(chapter) {
    return axios.put(CHAPTER + `id/${chapter.id}/edit`, { chapter })
    .then(response => response.data.updated);
  }

  remove(chapterId, ownerId) {
    return axios.post(CHAPTER + `id/${chapterId}/remove`, { user: { id: ownerId } }, { withCredentials: true })
    .then(response => response.data.chapter)
  }

  search(query, options) {
    return axios.post(CHAPTER + "search/" + query, { options })
    .then(response => response.data.chapters);
  }

}

const chapterCalls = new ChapterCalls();
export default chapterCalls;
